module.exports = __webpack_public_path__ + "static/media/18ECA14.4f045d3d.jpg";